require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-ruby-on-rails-rake-tasks-chart.json") })
        }
      }, "path---blog-ruby-on-rails-rake-tasks-chart");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-ruby-on-rails-rake-tasks-chart!./.cache/json/blog-ruby-on-rails-rake-tasks-chart.json
// module id = 1053
// module chunks = 231608221292675